import React from 'react'
// import { useIsLargeDesktop } from '../../../../hooks'
import ConnectButton from 'components/Common/Button/ConnectButton'
import { useNavigate } from 'react-router-dom'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

const UnclaimedBusinessProfile = props => {
  // const isLargeDesktop = useIsLargeDesktop()
  const navigate = useNavigate()

  const onClaimBusinessClick = () => {
    navigate('/find')
  }

  return (
    <Box
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
       <Typography variant="h6" color="#0A78CD" sx={{ margin: '0px 8px 20px 8px' }}>
        Be in control of your data
      </Typography>
      <ConnectButton
        onClick={onClaimBusinessClick}
        label="Claim your business"
        tooltipPlacement="bottom"
        isConnected={false}
        primary
      />
    </Box>
  )
}

export default UnclaimedBusinessProfile
